import { render, staticRenderFns } from "./transport-vehicle-infos.vue?vue&type=template&id=ebb6f108&scoped=true&"
import script from "./transport-vehicle-infos.vue?vue&type=script&lang=js&"
export * from "./transport-vehicle-infos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb6f108",
  null
  
)

export default component.exports